import React , { createRef } from "react";
import PropTypes from "prop-types";
import "./autocomplete.css";
import "./MoneyTransfer.css"
import { Icon, TextField, InputAdornment} from "@material-ui/core";
import axios from 'axios';
import custLodAsh from '@lodash';

class Autocomplete extends React.Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array)
  };

  static defaultProps = {
    suggestions: []
  };

  constructor(props) {
    super(props);
    //START: Bug 5010 Search Customer Bug
    this.dropDownRef = createRef();
    this.closeDropDown = this.closeDropDown.bind(this);
    //END: Bug 5010 Search Customer Bug
    this.state = {
      // The active selection's index
      activeSuggestion: -1,
      // The suggestions that match the user's input
      clientfiltSuggestions: [],
      // Whether or not the suggestion list is shown
      clientListshowSuggestions: true,
      // What the user has entered
      userClientInput: props.coName ? props.coName: "",
      //initial input
      usrClientInput: "",
      // Track if user is actively editing the input
      isEditing: false,
      // Stores the last confirmed (selected or pre-populated) display text for restoration on click-outside
      lastConfirmedInput: props.coName ? props.coName : "",
      flag: false, tmpCustomerListSuggestion: []
    };
    this.debouncedMainCustomerSearch = custLodAsh.debounce(this.mainCustomerSearch, 300);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {money, coName, secondFlag, autoCoFlag} = nextProps;
    const {flag, isEditing} = prevState;
    const hasFlagOrSecond = flag || secondFlag;
    const hasMoneyAndCoName = money && coName;
    if(hasMoneyAndCoName && hasFlagOrSecond && !isEditing) 
      return { userClientInput: coName}
    if(typeof autoCoFlag === 'boolean') {
      let finalObj = {};
      finalObj = flag && autoCoFlag ? {flag: false} : {};
      if(!autoCoFlag && !flag)
        finalObj = {userClientInput:''};
      return {...finalObj}
    }
    return null;
  }

  componentDidMount() {
    this.fetchCustomerList({mount: true, limit: true})
    //START: Bug 5010 Search Customer Bug: Register one event for click away listener...
    document.addEventListener("mousedown", this.closeDropDown);
    //END: Bug 5010 Search Customer Bug
  }

  //START: Bug 5010 Search Customer Bug : De-Register one event for click away listener...
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.closeDropDown);
  }

  closeDropDown(e) {
    const {money, toInd} = this.props;
    const indTxt = money && typeof toInd === 'number' ? toInd : '';
    const errorDropDownId = toInd ? toInd : '';
    const inputId = money ? `MoneyDropDown${indTxt}` : `ErrorDropDown${errorDropDownId}`;
    // Skip when user clicks the input itself or on a suggestion item inside the dropdown
    const isClickOnInput = e.target.id === inputId;
    const isClickInsideDropdown = this.dropDownRef.current && this.dropDownRef.current.contains(e.target);
    if (isClickOnInput || isClickInsideDropdown) return;

    const {isEditing, lastConfirmedInput} = this.state;
    // Check if the suggestion dropdown is currently open
    const isDropdownOpen = this.state.clientListshowSuggestions && !!this.dropDownRef.current;

    // Restore previous confirmed value when editing (even if dropdown not yet open due to debounce delay)
    // Also close the dropdown if it was open
    if (isDropdownOpen || isEditing) {
      this.setState({
        activeSuggestion: 0,
        clientfiltSuggestions: [],
        clientListshowSuggestions: false,
        ...(isEditing ? { userClientInput: lastConfirmedInput || '', isEditing: false } : {})
      });
    }
  }
  //END: Bug 5010 Search Customer Bug

    // ...existing code...
  fetchCustomerList = async ({ showSuggest, limit, mount }) => {
    const { setCustomerVal } = this.props;
    try {
      const { userClientInput } = this.state;
      const response = await axios.post('/api/bankRec/fetchCustomerList', { userClientInput, limit, mount });
      const { resJson: filtCustSug } = response.data.data;
      const tmpCustomerListSuggestion = filtCustSug;
      const tmpCustSuggest = showSuggest
        ? { clientfiltSuggestions: ['Add New', ...tmpCustomerListSuggestion], clientListshowSuggestions: true }
        : {};
  
      this.setState(
        {
          activeSuggestion: -1,
          tmpCustomerListSuggestion,
          ...tmpCustSuggest,
          ...(showSuggest ? { isEditing: true } : {})
        },
        () => {
          this.handleSetCustomerVal({ setCustomerVal, mount, userClientInput, filtCustSug });
        }
      );
    } catch (errCustomerListError) {
      console.error(errCustomerListError);
      if (setCustomerVal && mount) {
        this.resetCustomerVal(setCustomerVal, mount);
      }
      if (mount) {
        const { userClientInput } = this.state;
        this.handleSetCustomerVal({ mount, userClientInput, filtCustSug: [] });
      }
    }
  };
  
  // FIX [Story-12622 / Bug-15816]: handleSetCustomerVal is called on component mount (via fetchCustomerList)
  // to resolve a pre-populated customer code (coName prop) into its full display name.
  // ROOT CAUSE: When a dialog opens with a default/pre-filled customer (e.g. Add Transaction,
  // Split Transaction, Edit Transaction from any screen with "Reconciling Item?"), the Autocomplete
  // displayed the customer name visually but never called onSelectChange. As a result, the parent's
  // clientName state remained "" and coName: "" was sent to the backend — so the bankRecCard kanban
  // card was created with no customer name. Manually changing the customer worked fine because onClick
  // always calls onSelectChange.
  //
  // CHANGES MADE (Story-12622):
  //   1. Kept filtCustSug.length === 1 — no change needed (backend guarantees 0 or 1 result on mount).
  //   2. Added onSelectChange call after resolving the matched customer on mount
  //      — this propagates {coName (display name), coId, custSearchText} back to the parent so that
  //        clientName is populated in parent state before the form is saved, ensuring the bankRecCard
  //        is created with the correct customer name.
  //   3. Destructured coName and coId from filtCustSug[0] (in addition to custSearchText) to pass
  //      to onSelectChange.
  //   4. Moved onSelectChange/money/coTxt/toInd destructure to the top of the function so it is
  //      shared between the match branch and the empty-result (clear) branch below.
  handleSetCustomerVal = ({ mount, userClientInput, filtCustSug }) => {
    if (!mount || typeof userClientInput !== 'string') return;
    const { onValidationComplete, showBankCo, onSelectChange, money, coTxt, toInd } = this.props;
    if (Array.isArray(filtCustSug) && filtCustSug.length === 1) {
      const { custSearchText, coName, coId } = filtCustSug[0];
      if (custSearchText) {
        // Update display text and lastConfirmedInput so click-outside restores the pre-populated display text
        this.setState({ userClientInput: custSearchText, lastConfirmedInput: custSearchText }, () => {
          // [Story-12622 FIX] Notify parent with full customer data (coName = display name, coId = customer code)
          // so the parent sets clientName in state — this ensures coName field in the save payload is
          // populated and the bankRecCard kanban card is created with the correct customer name.
          if (onSelectChange) {
            const obj = money ? { toInd } : {};
            onSelectChange({ coName: coName || '', coId: coId || '', custSearchText, obj, coTxt });
          }
          // Signal parent that the pre-filled customer was confirmed — Save button can now be enabled
          if (onValidationComplete) onValidationComplete();
        });
        return;
      }
    }
    // If API returns no results, clear the input so a stale coName prop value does not persist.
    // Also notify the parent via onSelectChange so the parent's coName state is cleared,
    // preventing the Save button from being enabled with an invalid customer.
    if (Array.isArray(filtCustSug) && filtCustSug.length === 0 && !showBankCo) {
      const clearObj = money ? { toInd } : {};
      this.setState({ userClientInput: '', lastConfirmedInput: '' }, () => {
        if (onSelectChange) {
          onSelectChange({ coName: '', coId: '', custSearchText: '', obj: clearObj, coTxt });
        }
        // Signal parent that validation is done (result: invalid — coName was cleared above)
        if (onValidationComplete) onValidationComplete();
      });
    }
  };
  
  resetCustomerVal = (setCustomerVal, mount) => {
    setCustomerVal({ coId: '', coName: '', custSearchText: '', mount });
  };
  // ...existing code...

  mainCustomerSearch = () => this.fetchCustomerList({showSuggest: true})

  onChange = e => {
    const currentInputValue = e.currentTarget.value;
    // Detect full keyboard clear before setState to include lastConfirmedInput reset in a single state update
    const isFieldCompletelyCleared = typeof currentInputValue === 'string' && !currentInputValue.trim();
    this.setState({
      userClientInput: currentInputValue,
      usrClientInput: currentInputValue,
      isEditing: true,
      // When all text is removed via keyboard, reset lastConfirmedInput so click-outside does not restore the old value
      ...(isFieldCompletelyCleared ? { lastConfirmedInput: '' } : {})
    }, () => {
      const { userClientInput: tmpOnChangeEmpInput } = this.state;
      const {onSelectChange: resetCustomer} = this.props;
      if (typeof tmpOnChangeEmpInput === 'string' && tmpOnChangeEmpInput.trim())
          this.debouncedMainCustomerSearch()
      if (typeof tmpOnChangeEmpInput === 'string' && !tmpOnChangeEmpInput.trim()) {
          const {toInd, money, coTxt} = this.props;
          const clearObj = money ? {toInd} : {};
          resetCustomer({ coName: '', coId: '', custSearchText: '', obj: clearObj, coTxt});
      }
    });
  }

  onClick = (e, userClientInput) => {
    const {custSearchText, coName, coId} = userClientInput && typeof userClientInput === 'object' ? userClientInput : {};
    const {onSelectChange, toInd, money, coTxt} = this.props;
    const obj = money ? {toInd} : {};
    const clickIndTxt = money && typeof toInd === 'number' ? toInd: '';
    if(money) {
      const onUnClickTab = document.getElementById(`MoneyDropDown${clickIndTxt}`);
      onUnClickTab.focus();
    } else {
      const onUnClickAddTab = document.getElementById(`ErrorDropDown${toInd ? toInd: ''}`);
      onUnClickAddTab.focus();
    }
    this.setState({
      activeSuggestion: 0,
      clientfiltSuggestions: [],
      clientListshowSuggestions: false,
      userClientInput: custSearchText,
      // Record confirmed selection so closeDropDown can restore it on click-outside after partial edit
      lastConfirmedInput: custSearchText,
      flag: true,
      isEditing: false
    }, ()=>{
        onSelectChange({coName: coName ? coName : '', coTxt,
          coId: coId ? coId : '', custSearchText, obj});
    });
  };

  scrollList = suggestion =>{
    const {money} = this.props;
    var list  = money ? document.querySelector('.moneysuggest-active') : document.querySelector('.suggestion-active');
    var ullist  = money? document.querySelector('.moneysuggest') : document.querySelector('.suggestions');
  
    var elHeight = list.clientHeight;
    var scrollTop = ullist.scrollTop;
    var viewport = scrollTop + ullist.clientHeight;
    var elOffset = elHeight * suggestion;
    
    if (elOffset < scrollTop || (elOffset + elHeight) > viewport) {
      ullist.scrollTop=elOffset;
    }
}

  onKeyDown = e => {
    const {money} = this.props;
    let downlist  = money ? document.querySelector('.moneysuggest') : document.querySelector('.suggestions');
    const { activeSuggestion, clientfiltSuggestions, userClientInput, clientListshowSuggestions} = this.state;

    if (e.keyCode === 13 && e.target.value.trim()!=='' && clientfiltSuggestions.length) {
      if(clientListshowSuggestions && activeSuggestion!==-1) {
            const suggest = clientfiltSuggestions[activeSuggestion];
            if(suggest === 'Add New') {
              this.openClientDialog('', userClientInput)
            } else {
              this.onClick('', suggest);
            }
      }
    }
    // User pressed the up arrow
    else if (e.keyCode === 38 && e.target.value.trim()!=='') {
     if(this.state.clientListshowSuggestions && activeSuggestion!==-1) {
     this.scrollList(activeSuggestion-1);
     }

      if(activeSuggestion === -1) {
        downlist.scrollTop = downlist.scrollHeight;
      this.setState({
        activeSuggestion: clientfiltSuggestions.length-1
      });
      return;
    }

      if (activeSuggestion === 0) {
        this.setState({
          activeSuggestion: -1,
          userClientInput: this.state.usrClientInput
        });
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow
  else if (e.keyCode === 40 && e.target.value.trim()!=='') {
   if(this.state.clientListshowSuggestions && activeSuggestion!==-1) {
      this.scrollList(activeSuggestion+1);
   }

     if (activeSuggestion - 1 === clientfiltSuggestions.length-2) {
       downlist.scrollTop=0;
       this.setState({
         activeSuggestion: -1,
         userClientInput: this.state.usrClientInput
         });
         return;
     }
      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  }

  clearInput = evt => {
    const {onSelectChange, toInd, money, coTxt} = this.props;
    const {tmpCustomerListSuggestion} = this.state;
      const clearObj = money ? {toInd} : {};
      this.setState({userClientInput: '',
      // Reset lastConfirmedInput since clearing is a confirmed action
      lastConfirmedInput: '',
      clientListshowSuggestions: true, clientfiltSuggestions: ['Add New', ...tmpCustomerListSuggestion],
      isEditing: true, flag: false
      }, ()=> {
        this.fetchCustomerList({showSuggest: true, limit: true});
        onSelectChange({coName:'', coId:'', custSearchText: '', obj: clearObj, coTxt})
      });
  }

  showSuggestion = (evt, inp) => {
    const {tmpCustomerListSuggestion} = this.state; const {money} = this.props;
    const onUnClick = document.getElementById(inp);
      if(onUnClick) {
        onUnClick.focus();
      }
      this.setState({
        userClientInput: '', clientListshowSuggestions: true, clientfiltSuggestions: ['Add New', ...tmpCustomerListSuggestion]
      },()=> {
        this.fetchCustomerList({showSuggest: true, limit: true});
        if(!money)
          this.props.onSelectChange({coName:'', coId:'', custSearchText: '', obj: {}})
      });
  }

  onBlurDropDown = () => {
    this.setState({clientListshowSuggestions: false, clientfiltSuggestions:[]});
  }

  onFocusDropDown = () => {
    const {tmpCustomerListSuggestion} = this.state;
    this.setState({clientListshowSuggestions: true, clientfiltSuggestions: ['Add New', ...tmpCustomerListSuggestion]});
  }

  openClientDialog = (evt, coId) => {
    const {openCliDialog} = this.props;
    this.setState({activeSuggestion: 0, userClientInput: '', clientListshowSuggestions: false, clientfiltSuggestions:[]}, ()=> {
      let tmpCoArg = coId.trim() && coId.indexOf('-')!==-1 ? coId.split('-')[0].trim() : coId;
      openCliDialog(tmpCoArg, true);
    });
  }

  render() {
    const {
      onChange,
      onKeyDown,
      state: {
        activeSuggestion,
        clientfiltSuggestions,
        clientListshowSuggestions,
        userClientInput
      }
    } = this;
    let suggestionsListComponent;
    const {money, placeHoldCo, toInd, topClass, inputAuoStyle, autoCompleteClass} = this.props;
    const indTxt = money && typeof toInd === 'number' ? toInd: '';
    const overRideStyle = topClass ? {...topClass} : {};
    const {labelStyle, inputStyle} = autoCompleteClass ? autoCompleteClass : {};
    if (clientListshowSuggestions) {
      if (clientfiltSuggestions.length) {
        suggestionsListComponent = (
          //START: Bug 5010 Search Customer Bug : use reference of mouse event on parent div...
          <ul className={money ? 'moneysuggest' : 'suggestions'} style={{...overRideStyle}} ref={this.dropDownRef}>
            {clientfiltSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = money ? "moneysuggest-active" : "suggestion-active";
              }
              return (
                <>
                  {suggestion === 'Add New' && 
                  <li key={suggestion} className={className} onClick={evt=>this.openClientDialog(evt, userClientInput)} role="option">
                    <span style={{fontSize:'27px', color:'#006400'}}>+</span>&nbsp;&nbsp;
                    <span style={{color:'#000000'}}>Add New <span style={{fontSize:'18px'}}>{userClientInput}</span></span>
                  </li>
                  }
                  {suggestion !== 'Add New' && <li className={className} key={suggestion.coId} onClick={e => this.onClick(e, suggestion)} role="option">
                    {suggestion.custSearchText}
                  </li>
                  }
                </>
              );
            })}
          </ul>
        );
      }
    }
    return (
      <>
        <TextField
              label={money && placeHoldCo ? <span style={labelStyle ? {...labelStyle}:{position:'relative', bottom:'2px'}}>{placeHoldCo}</span> : <span style={labelStyle ? {...labelStyle}:{position:'relative', bottom:'2px'}}>{money ? 'Customer *...' : `${userClientInput ? 'Customer' : 'Search Customer'} ${inputAuoStyle ? '': '*'}...`}</span>}
              type="text" variant="outlined"
              fullWidth value={userClientInput}
              inputProps={{
                  'aria-label': ''
              }}
              InputProps={{
                style:inputStyle ? {...inputStyle}:{},
                endAdornment: (
                  <InputAdornment position="end">
                    {userClientInput && (
                      <Icon aria-hidden="true" style={{cursor: 'pointer',fontSize:'20px'}} onClick={evt =>this.clearInput(evt)}>clear</Icon>
                    )}
                    <Icon aria-hidden="true" style={{cursor: 'pointer',fontSize:'20px'}} onClick={evt =>this.showSuggestion(evt, "ErrorDropDown")}>arrow_drop_down</Icon>
                  </InputAdornment>
                )
              }}
              onChange={onChange} autoComplete="off"
              onKeyDown={onKeyDown} id={money ? `MoneyDropDown${indTxt}` : `ErrorDropDown${toInd ? toInd: ''}`}
              onFocus={this.onFocusDropDown.bind(this)}
        />
        {suggestionsListComponent}
      </>
    );
  }
}

export default Autocomplete; 